import { useAtom, PrimitiveAtom } from "jotai";

interface IDisclosure {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  onToggle: () => void;
}

export function useJotaiDisclosure(
  disclosureAtom: PrimitiveAtom<boolean>,
): IDisclosure {
  const [isOpen, setIsOpen] = useAtom(disclosureAtom);
  const onClose = () => setIsOpen(false);
  const onOpen = () => setIsOpen(true);
  const onToggle = () => setIsOpen(!isOpen);

  return { isOpen, onOpen, onClose, onToggle };
}
